import React from 'react';
import dynamic from 'next/dynamic';

const LineCallbackDynamicNoSSR = dynamic(
    () => import("@tw/customer-identity-cra/lib/login/line-callback"),
    { ssr: false }
);

function LineCallback() {
    return <LineCallbackDynamicNoSSR />;
}

LineCallback.reduxModules = LineCallbackDynamicNoSSR.reduxModules;
LineCallback.getInitialProps = () => { return {}};
LineCallback.domainName = "customer-identity";

export default LineCallback;